import { AppBar, Box } from '@mui/material';
import logo from '@public/logo-words-grey.png';
import type { FC } from 'react';
import { useContext } from 'react';
import { useCookies } from 'react-cookie';

import { SlabContext } from '@core/context/SlabContext';
import Enums from '@core/types/api/Enums';
import { useSlabAuth } from '@web/hooks/useSlabAuth';

import { GlobalSearchInput } from '../GlobalSearch/GlobalSearchInput';
import { TenantSelectionMenu } from '../NavBar/TenantSelectionMenu';
import { NotificationBell } from '../NotificationCenter/NotificationBell';
import { QuickActionsButton } from '../QuickActions/QuickActionsButton';
import { AppNavbarLogoWrapper, Menu, Toolbar, ToolbarImpersonating } from './styles';

interface AppNavbarProps {
  isOpen: boolean;
  toggleDrawer(): void;
}

export const AppNavbar: FC<AppNavbarProps> = ({ toggleDrawer, isOpen }) => {
  const { userInfo } = useContext(SlabContext);
  const { logout, user } = useSlabAuth();
  const [{ AuthOverride: authOverride }] = useCookies(['AuthOverride']);

  const isImpersonating = user?.admin && (authOverride ?? '') !== '';
  const hasGlobalSearch = userInfo.hasFlags([Enums.FeatureFlagName.FeatureFlagGlobalSearch]);
  const hasQuickActions = userInfo.hasFlags([Enums.FeatureFlagName.FeatureFlagQuickActions]);
  const hasNotificationCenter = userInfo.hasFlags([
    Enums.FeatureFlagName.FeatureFlagNotificationCenter,
  ]);

  return (
    <AppBar position='fixed'>
      <Toolbar isOpen={isOpen}>
        <Menu onClick={toggleDrawer} />

        {hasGlobalSearch || hasQuickActions ? (
          <Box display='flex' gap={2}>
            {hasGlobalSearch && <GlobalSearchInput />}
            {hasQuickActions && <QuickActionsButton />}
          </Box>
        ) : (
          <AppNavbarLogoWrapper display='flex'>
            <Box component='img' height={48} src={logo} />
          </AppNavbarLogoWrapper>
        )}

        <ToolbarImpersonating isImpersonating={isImpersonating} />

        {user !== undefined && (
          <Box display='flex' alignItems='center' gap={1}>
            <TenantSelectionMenu auth0User={user} logout={logout} />
            {hasNotificationCenter && <NotificationBell />}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};
